module.exports = __webpack_public_path__ + "static/StampRischioZero-5a13cbfea8348437c1dfa5725eb9560c.svg";